import React, { useContext, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { SettingsContext } from '../contexts/index.jsx';
import { ValidationHelper } from "../helpers";
import { Alert, FieldGroup, SubmitButton } from "../components";
const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const RecoverAccount = (props) => {
  const settings = useContext(SettingsContext);
  const [status, setStatus] = useState("input");

  const recaptchaRef = useRef();

  const onSubmit = async (values) => {
    const token = await recaptchaRef.current.executeAsync("recovery");
    await axios.post("/api/email-verifications", {
      type: "recovery",
      email: values.email,
      recaptcha: token,
    });

    setStatus("success");
  };

  return (
    <main id="recover-account">
      <div className="container">
        {status === "success" && (
          <Alert
            type="success"
            message="Submission successful"
            clasName="mb-4"
            description="If there is an account associated with the email address, we will send an email with further instructions."
          />
        )}

        <p>
          Enter your email address in the form below. We will send you an email
          with further instructions.
        </p>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={ValidationHelper.schema(["email"])}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <FieldGroup placeholder="Email" type="email" name="email" />

              <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={RECAPTCHA_SITE_KEY}
              />

              <div className="action-row mt-4 mb-4">
                <SubmitButton
                  isSubmitting={isSubmitting}
                  label="Recover Account"
                />
              </div>
            </Form>
          )}
        </Formik>

        {!settings?.isShopify && (
          <p className="small-text mb-4 mb-xxl-0">
            You may also{" "}
            <Link to={`/create-account?${settings.iframeQueryParams}`}>
              create a new account
            </Link>{" "}
            or{" "}
            <Link to={`/sign-in?${settings.iframeQueryParams}`}>sign-in</Link>.
          </p>
        )}
      </div>
    </main>
  );
};

export default RecoverAccount;
